import { ERROR_LOG_FIELDS } from '@/utils/constants';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'error-popup',
})

export default class ErrorPopup extends Vue {

    // ----------------------------------------------------------------
    // Properties
    @Prop()
    private rowsArray: any;

    @Prop()
    private propBind: any;

    @Prop({ default: 'Error Logs' })
    private cardName: any;

    private errorLogFields = ERROR_LOG_FIELDS;
    // -----------------------------------------------------------------
    // Action

    private onClose() {
        this.$emit('onClose');
    }

    private mounted() {
        document.addEventListener('keydown', ({key}) => {
            if (key === 'Escape') {
                this.$emit('onClose');
            }
        });
    }

}
